<div class="wrapper-fade">
  <div class="wrapper-fade-2">
    <div #scroller class="scrolling-wrapper-flexbox justify-content-md-center">
      <div class="calendar">
        <div id="ajax-load-slots-diagram" class="slots-diagram">
          <div class="slots-diagram-box">
            <div class="container slots-diagram-group">
              <!-- COL START -->
              <div *ngFor="let bookingSlot of bookingSlots; let slotIndex = index" class="slot-diagram scrolling-wrapper-flexbox-box slot-diagram-free"
              (click)="onClickBookingSlot($event, bookingSlot)"
              [class.slot-diagram-selected]="isSlotSelected(bookingSlot)"
              >
                <div class="slot-diagram-top">
                  <span class="tooltiptext tooltip-top" [innerHTML]="getBookingSlotToolTip(bookingSlot) | translate:{ticketsAvailable: bookingSlot.freeQuantity}">
                  </span>
                </div>
                <div class="slot-diagram-body">
                  <div>
                    <div class="slot-diagram-bar" [style.height.%]='getBookingSlotHeight(bookingSlot)'>&nbsp;</div>
                  </div>
                </div>
                <div class="slot-diagram-footer">
                  <div>{{ bookingSlot.toString() }}</div>
                </div>
              </div>
              <!-- COL END -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
